// extracted by mini-css-extract-plugin
export default {"cls1":"AcademiaIcon-cls1___8284bde52f87efc2857","cls2":"AcademiaIcon-cls2___a04ac7e6e682a33f978 AcademiaIcon-cls1___8284bde52f87efc2857"};